function post(url, data) {
	return fetch(url, {
		method: "POST", // or 'PUT'
		body: JSON.stringify(data), // data can be `string` or {object}!
		headers: new Headers({
			"Content-Type": "application/json",
		}),
	});
}

function downloadCsv(rows, filename, tableObj) {
	const title_name = {};
	const summary_rows = {};
	let hasSummary = false;
	const props = [];
	for(const column of tableObj.store.states.originColumns) {
		const property = column.property || (column.children && column.children[0] && column.children[0].property) || null;
		if(property) {
			props.push(property)
			if(column.filterPlacement!=''){
				title_name[property] = column.filterPlacement;
			}else{
				title_name[property] = column.label;
			}
			if (column.children) {
				hasSummary = true;
				summary_rows[property] = column.children[0].label;
			} else {
				summary_rows[property] = '--';
			}
		}
	}
	const processRow = function (row) {
		row = props.map(t=>{
			return row[t]
		})
		var finalVal = '';
		for (var j = 0; j < row.length; j++) {
			var innerValue = row[j] === undefined ? '' : row[j].toString();
			if (row[j] instanceof Date) {
				innerValue = row[j].toLocaleString();
			}
			var result = innerValue.replace(/"/g, '""');
			if (result.search(/("|,|\n)/g) >= 0)
				result = '"' + result + '"';
			if (j > 0)
				finalVal += ',';
			finalVal += result;
		}
		return finalVal + '\n';

	};

	var csvFile = '';
	csvFile +=processRow(title_name);
	if (hasSummary) {
		csvFile +=processRow(summary_rows);
	}
	for (var i = 0; i < rows.length; i++) {
		csvFile += processRow(rows[i]);
	}

	var blob = new Blob([csvFile], { type: 'text/csv;charset=utf-8;' });
	if (navigator.msSaveBlob) { // IE 10+
		navigator.msSaveBlob(blob, filename);
	} else {
		var link = document.createElement("a");
		if (link.download !== undefined) { // feature detection
			// Browsers that support HTML5 download attribute
			var url = URL.createObjectURL(blob);
			link.setAttribute("href", url);
			link.setAttribute("download", filename);
			link.style.visibility = 'hidden';
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		}
	}
}


export { post, downloadCsv };
